<template>
    <b-row>
        <b-table :fields="fields" :items="participantes" :busy="tableBusy" :current-page="currentPage" hover
            no-border-collapse sort-by="" :sort-desc="true" stacked="sm" responsive show-empty>
            <template #empty>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
                <div class="text-center text-dark">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="loading-text">Carregando...</strong>
                </div>
            </template>
        </b-table>
        <table-pagination v-if="totalRows > pageSize" :total-rows=totalRows :per-page=pageSize @pageChange="pageChange" />
    </b-row>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'


import ldiService from '@/services/licitacoes/ldiService'
import { fieldsParticipanteLicitacao } from '@/types/licitacoes/ldi/fields-participante-licitacao'
import { ParticipanteLicitacao } from '@/types/licitacoes/ldi/participante-licitacao'

import TablePagination from "@/components/atos-pessoal/TablePagination.vue";

import { TableField } from '@/types/table-field'
import { fieldsParticipantes } from '@/types/licitacoes/fields-participantes'


const CompProps = Vue.extend({
    name: 'DetalhesParticipantes',
    components: { TablePagination },
    props: {
        licitacao: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class DetalhesParticipantes extends mixins(UtilsTS, CompProps) {
    fields: TableField[] = fieldsParticipanteLicitacao
    participantes: ParticipanteLicitacao[] = []

    //table-related
    currentPage = 1
    pageSize = 10
    totalRows = 0
    tableBusy = false

    async mounted() {
        this.loadData()
    }

    async loadData() {
        try {
            this.tableBusy = true
            const response = await ldiService.buscarParticipantes(this.licitacao.IdLicitacao, this.currentPage, this.pageSize)
            if (response) {
                this.participantes = response.participantes.map(l => {
                    const participante = Object.assign(new ParticipanteLicitacao(), l)
                    return participante
                })
                //console.log(this.participantes)
                this.totalRows = response.totalRows
            } else {
                this.$toast.error('Erro ao consultar os lotes/itens de licitações.');
            }
        } finally {
            this.tableBusy = false;
        }
    }

    async pageChange(value) {
        this.currentPage = value;
        await this.loadData();
    }
}
</script>

<style></style>

<style scoped>
div.row>div>span:first-child {
    font-weight: bolder;
    display: block;
}
</style>